import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const HasBabyCarraige = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8327 1.6665V8.33317H17.4994C17.4994 6.56506 16.797 4.86937 15.5467 3.61913C14.2965 2.36888 12.6008 1.6665 10.8327 1.6665ZM16.0993 13.2415C17.0072 12.0772 17.4999 10.6429 17.4994 9.1665H5.36602L4.58268 7.49984H1.66602V9.1665H3.51602C3.51602 9.1665 5.09102 12.5582 5.28268 12.8498C4.36602 13.3332 3.74935 14.3082 3.74935 15.4165C3.74935 16.19 4.05664 16.9319 4.60362 17.4789C5.1506 18.0259 5.89247 18.3332 6.66602 18.3332C8.13268 18.3332 9.34935 17.2498 9.54935 15.8332H11.2827C11.4827 17.2498 12.6994 18.3332 14.166 18.3332C14.9396 18.3332 15.6814 18.0259 16.2284 17.4789C16.7754 16.9319 17.0827 16.19 17.0827 15.4165C17.0827 14.5498 16.6994 13.7748 16.0993 13.2415ZM6.66602 16.6665C6.3345 16.6665 6.01655 16.5348 5.78213 16.3004C5.54771 16.066 5.41602 15.748 5.41602 15.4165C5.41602 15.085 5.54771 14.767 5.78213 14.5326C6.01655 14.2982 6.3345 14.1665 6.66602 14.1665C6.99754 14.1665 7.31548 14.2982 7.5499 14.5326C7.78432 14.767 7.91602 15.085 7.91602 15.4165C7.91602 15.748 7.78432 16.066 7.5499 16.3004C7.31548 16.5348 6.99754 16.6665 6.66602 16.6665ZM14.166 16.6665C13.8345 16.6665 13.5166 16.5348 13.2821 16.3004C13.0477 16.066 12.916 15.748 12.916 15.4165C12.916 15.085 13.0477 14.767 13.2821 14.5326C13.5166 14.2982 13.8345 14.1665 14.166 14.1665C14.4975 14.1665 14.8155 14.2982 15.0499 14.5326C15.2843 14.767 15.416 15.085 15.416 15.4165C15.416 15.748 15.2843 16.066 15.0499 16.3004C14.8155 16.5348 14.4975 16.6665 14.166 16.6665Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default HasBabyCarraige;
